import {useConfig} from '@aboutyou/config';
import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  GetDeliveriesTimeDiffRequest_Package,
  GetDeliveriesTimeDiffResponse,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/service.types';
import {Log} from '@aboutyou/mlm';
import React, {useEffect} from 'react';
import {useGetDeliveriesTimeDiffRequest} from './utils/useGetDeliveriesTimeDiffRequest';

export const TrackDeliveryTimeDifferences: React.FC<{
  deliveryTrackerPackages: GetDeliveriesTimeDiffRequest_Package[];
}> = ({deliveryTrackerPackages}) => {
  return (
    <DataFetcher
      request={useGetDeliveriesTimeDiffRequest(deliveryTrackerPackages)}
      View={TrackDeliveryTimeDifferencesView}
      Error={() => null}
    />
  );
};

const TrackDeliveryTimeDifferencesView: React.FC<
  GetDeliveriesTimeDiffResponse
> = ({deliveriesTimeDiff}) => {
  const {device} = useConfig();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    for (const deliveryTimeDiff of deliveriesTimeDiff) {
      Log.info('@aboutyou/logic-components', 'Delivery time diff', {
        device,
        delivery_estimation: true, // used for filtering on DD
        shop_id: deliveryTimeDiff.shopId,
        multi_products_pkg: deliveryTimeDiff.multipleProductsInPackage,
        product_id: deliveryTimeDiff.productId,

        adp_min: deliveryTimeDiff.adpDeliveryTimeMin,
        adp_max: deliveryTimeDiff.adpDeliveryTimeMax,
        osp_min: deliveryTimeDiff.ospDeliveryTimeMin,
        osp_max: deliveryTimeDiff.ospDeliveryTimeMax,
        diff_min: deliveryTimeDiff.deliveryDiffMin,
        diff_max: deliveryTimeDiff.deliveryDiffMax,
      });
    }
  }, [deliveriesTimeDiff]);

  return null;
};
